export const insideImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/93DxAMH2JEdePXYeNTnMk5/Captura_de_pantalla_2026-09-29_003212.png',
    alt: 'Inside page: Open Position — your partnerwork home base',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pxUcqHmNAsZHozDoGxJUYA/Captura_de_pantalla_2026-09-29_003037.png',
    alt: 'Inside page: 8 partnerwork errors you can see immediately',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vMkgQwpdWK49s67yve4VPX/Captura_de_pantalla_2026-09-29_003000.png',
    alt: 'Inside page: Right turn — full visual breakdown',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8jpRxDVvW6ZosDmqgC5zF2/Captura_de_pantalla_2026-09-29_002939.png',
    alt: 'Inside page: Open the lane — Salsa cross-body pathway floor map',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sWPPJcgi69DPinMqyqkL3q/Captura_de_pantalla_2026-09-29_002919.png',
    alt: 'Inside page: Leading is not pulling — pulling vs. leading comparison',
  },
]
